import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { isNil } from 'shared/src/utils';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useFixedCouponSno } from '../hooks/useFixedCouponSno';
import { GoodsParamsContext } from '../context/GoodsParamsContext';

export const useGoodsDetail = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  // 찜탭 등 route 밖 진입(logging 주입)에서는 카드 데이터로 로깅하므로 PDP 상세 API 를 호출하지 않는다.
  const injected = useContext(GoodsParamsContext);
  return useQuery({
    queryKey: queryKey.goodsDetail(goodsSno, fixedCouponSno),
    queryFn: () => goodsService.getGoodsDetail(goodsSno, fixedCouponSno),
    enabled: isNil(injected?.logging),
  });
};
